module.exports = __webpack_public_path__ + "static/img/HigheredLogo.4ee125f1.svg";